import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Image,
  Icon,
  // Dropdown,
} from "semantic-ui-react";
import { scrollFunction } from "../functions/Functions";
import { data1 } from "./Data";
class Navbar extends Component {
  state = {
    open: false,
    openLeft: false,
  };

  //****************** */
  handleLoginModal = () => {
    this.props.openModal("LoginModal");
  };
  handleRegisterModal = () => {
    this.props.openModal("RegisterModal");
  };
  //^^^^^^^^^^^^^^^
  //****************** */

  toggleDisplay = () => {
    this.setState({ open: !this.state.open });
  };

  toggleDisplayLeft = () => {
    this.setState({ openLeft: !this.state.openLeft });
  };
  handleContactUsModal = () => {
    this.props.openModal("ContactUsModal");
    this.toggleDisplay();
  };
  // *****************************************

  render() {
    //$$$$$$$$$$$$$$$$$$$$$$$$$$$

    const renderShowHideSidebarButton = () => {
      return this.state.open === true ? (
        <>
          <button
            className="buttonSide"
            style={{ backgroundColor: "dodgerblue" }}
            onClick={this.toggleDisplay}
          >
            <Icon name="close" />
          </button>
        </>
      ) : (
        <>
          <button
            className="buttonSide"
            style={{ backgroundColor: "dodgerblue" }}
            onClick={this.toggleDisplay}
          >
            <Icon name="sidebar" />
          </button>
        </>
      );
    };

    // @@@@@
    const renderShowHideSidebarButtonLeft = () => {
      return this.state.openLeft === true ? (
        <>
          <div
            className="buttonSide"
            // style={{fontSize:'18px',height:'30px',color:'white'}}
            onClick={this.toggleDisplayLeft}
          >
            <Icon name="close" />
          </div>
        </>
      ) : (
        <>
          <button
            className="buttonSide"
            // style={{fontSize:'18px',height:'30px',color:'white'}}
            onClick={this.toggleDisplayLeft}
          >
            <Icon name="sidebar" />
          </button>
        </>
      );
    };

    const authLinks = (
      <div>
        <nav id="navbar-top-wrapper" className="font-family-Roboto">
          <div id="navbar-top-a" className="nodisplay-at-tab">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Image
                className=" border-logo box-shadow-1 "
                size="small"
                src="/logo.png"
                style={{ marginRight: ".5em" }}
              />
              <div>
                {this.props.userA !== null &&
                  (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') &&
                  renderShowHideSidebarButtonLeft()}

                <div
                  className={
                    this.state.openLeft
                      ? "menu-left-wrapper menu-left-open "
                      : "menu-left-wrapper  "
                  }
                >
                  <div
                    onClick={this.toggleDisplayLeft}
                    style={{ width: "200px" }}
                    className="card font-16B color-white bgColor-CornflowerBlue flex-center border-radius-05"
                  >
                    {/*  */}
                    <div className="dividerGr"></div>
                    <div
                      className="py-05"
                      onClick={() =>
                        this.props.openModal("CreateFormWebModal", {
                          award: true,
                        })
                      }
                    >
                      <span className="link-gr cursor-pointer ">
                        Create Award
                      </span>
                    </div>

                    <div className="dividerGr"></div>

                    <div
                      className="py-05"
                      onClick={() =>
                        this.props.openModal("CreateFormWebModal", {
                          propOverview: true,
                        })
                      }
                    >
                      <span className="link-gr cursor-pointer">
                        Create Prop Overview
                      </span>
                    </div>
                    <div className="dividerGr"></div>

                    {/* <div
                      className="py-05"
                      onClick={() =>
                        this.props.openModal("CreateFormWebModal", {
                          review: true,
                          btn: true,
                        })
                      }
                    >
                      <span className="link-gr cursor-pointer">
                        Create Review
                      </span>
                    </div>
                    <div className="dividerGr"></div> */}
                    {this.props.userA !== null &&
                (this.props.userA.userType === 'admin' ) &&
                
                    <div
                    className="py-05"
                    
                  >
                    <span className="link-gr cursor-pointer" >
                    <Link className="link-gr" to="/UserList">
                    User List
                    </Link> 
                    </span>
                  </div>}
                  <div className="dividerGr"></div>
                  </div>
                </div>
              </div>
              {/*  */}
            </div>
            {/* this only work in < div id="navbar-top-a"> */}
            <div>
              {renderShowHideSidebarButton()}

              <div
                className={
                  this.state.open ? "menu-wrapper menu-open " : "menu-wrapper  "
                }
              >
                <ul className="disflex-paginator">
                  {/*  */}
                  <li className="px-0  ">
                    <button
                      style={{ width: "170px", borderRadius: "1px" }}
                      className="buttonG "
                    >
                      <span
                        onClick={() => {
                          scrollFunction("home");
                          this.toggleDisplay();
                        }}
                        // onClick={this.toggleDisplay}
                        style={{ padding: "0px 25px" }}
                        className="font-nav-link link-gr"
                        // href="#home"
                      >
                        <Icon>
                          <i className="home icon"></i>
                        </Icon>
                      </span>
                    </button>
                  </li>
                  {/*  */}

                  <li>
                    <div
                      tabIndex={"0"}
                      style={{ marginTop: "-4px", marginBottom: "-4px" }}
                      className="dropdown-container-gr"
                    >
                      <button
                        tabIndex={"0"}
                        style={{
                          width: "170px",
                          marginTop: "0px",
                          borderRadius: "1px",
                        }}
                        className="button-dd-head"
                      >
                        <div>
                          <Icon name="user outline" />
                        </div>
                      </button>
                      <ul
                        tabIndex={"0"}
                        style={{ marginTop: "50px" }}
                        className=""
                      >
                        <div
                          // onClick={this.toggleDisplay}
                          tabIndex={"0"}
                          style={{
                            position: "relative",
                            right: "150px",
                            top: "-80px",
                          }}
                          className=""
                        >
                          {!this.props.isAuthenticated && (
                            <button
                              onClick={this.handleLoginModal}
                              style={{ width: "150px" }}
                              className="buttonG"
                            >
                              <Link to="" onClick={this.toggleDisplay}>
                                <Icon name="power" />
                                Sign In
                              </Link>
                            </button>
                          )}

                          {this.props.isAuthenticated && (
                            <button
                              onClick={this.props.onLogoutClick}
                              style={{ minWidth: "150px" }}
                              className="buttonG"
                            >
                              <Link to="" onClick={this.toggleDisplay}>
                                <Icon name="power" />
                                Sign Out
                              </Link>
                            </button>
                          )}
                        </div>
                      </ul>
                    </div>
                  </li>

                  {/*  */}

                  {data1.map((val) => {
                    return (
                      <li
                        className="px-0  "
                        key={val.name}
                        // onClick={this.toggleDisplay}
                      >
                        <button
                          style={{ width: "170px", borderRadius: "1px" }}
                          className="buttonG"
                        >
                          <span
                            onClick={() => {
                              val.fn();
                              this.toggleDisplay();
                            }}
                            className="font-nav-link link-gr"
                          >
                            {val.name}
                          </span>
                        </button>
                      </li>
                    );
                  })}

                  <li className="px-0">
                    <button
                      style={{
                        marginTop: "-1px",
                        width: "170px",
                        borderRadius: "1px",
                      }}
                      className="buttonG"
                    >
                      <span
                        onClick={() => {
                          scrollFunction("contact");
                          this.toggleDisplay();
                        }}
                        className="font-nav-link link-gr"
                      >
                        Contact Us
                      </span>
                    </button>
                  </li>

                  <li>
                    <div
                      tabIndex={"0"}
                      style={{ marginTop: "-4px" }}
                      className="dropdown-container-gr"
                    >
                      <button
                        tabIndex={"0"}
                        style={{
                          width: "170px",
                          marginTop: "0px",
                          borderRadius: "1px",
                        }}
                        className="button-dd-head"
                      >
                        <div>Properties</div>
                      </button>
                      <ul
                        tabIndex={"0"}
                        style={{ marginTop: "50px" }}
                        className=""
                      >
                        <div
                          tabIndex={"0"}
                          style={{
                            position: "relative",
                            right: "150px",
                            top: "-80px",
                          }}
                          className=""
                        >
                          <button
                            style={{ width: "230px" }}
                            className="buttonG"
                          >
                            {" "}
                            <Link to="/dwk/">Dwarka</Link>{" "}
                          </button>

                          <button
                            style={{ minWidth: "230px" }}
                            className="buttonG"
                          >
                            {" "}
                            <Link to="/ggn/">Dwarka Expressway</Link>{" "}
                          </button>
                        </div>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {/*  */}
          </div>
        </nav>
      </div>
    );

    return <div>{authLinks}</div>;
  }
}
//@@@@@@@@@@@@@@@@@

export default Navbar;
